import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import axios from "axios";

import { ParseUserAgent } from "../../../Libs/Devices/ParseUserAgent"

import { Language } from "../../../Libs/Devices/Language";
/*
import { storageSet, storageGet } from '../../../Libs/Collector/StorageAction'
import { cookieSet } from '../../../Libs/Collector/CookieAction'
*/
import api from "../../../Libs/Api/AxiosConfig";

import { storageGet, storageSet } from "../../../Libs/Collector/StorageAction";
import { cookieSet } from "../../../Libs/Collector/CookieAction";


export const getApps = createAsyncThunk(
    'Apps/getApps',
    async () => {

        const apiData = {
            channel: process.env.REACT_APP_CHANNEL,
            clientId: storageGet("clientId"),
            activityId: storageGet("activityId"),
            browserName: ParseUserAgent.browserName,
            deviceType: ParseUserAgent.deviceType,
            fullBrowserVersion: ParseUserAgent.fullBrowserVersion,
            getUA: ParseUserAgent.getUA,
            mobileModel: ParseUserAgent.mobileModel,
            mobileVendor: ParseUserAgent.mobileVendor,
            osName: ParseUserAgent.osName,
            osVersion: ParseUserAgent.osVersion,
            browserLanguage: Language()[0],
            currency: "USD",
        }

        const res = await api.post(`/User/Init/InitApp`, apiData);
        return res.data;
    }
);

export const AppSlice = createSlice({
    name: "Apps",
    initialState: {
        loading: true,
        logo: "",
        loginBg: "",
        logoIcon: "",
        signupBg: "",
        error: false,
        errorData: [],
        language: [],
        currency:[],
        captchaToken: "",
        selectedCurrency:"",
        selectedLanguage:"",
    },
    reducers: {
        errorReducer: (state, action) => {
            state.error = true;
            state.errorData = action;
        },
        errorCloseReducer: (state) => {
            state.error = false;
        },
        setCaptcha: (state, action) => {
            state.captchaToken = action.payload
        }

    },
    extraReducers: (builder) => {
        builder.addCase(getApps.pending, (state, { payload }) => {
            state.loading = true;
        });
        builder.addCase(getApps.fulfilled, (state, { payload }) => {

            const pl = payload.payload.data;
            state.logo = pl.logo;
            state.loginBg = pl.loginBg;
            state.logoIcon = pl.logoIcon;
            state.signupBg = pl.signupBg;
            state.language = pl.language;
            state.currency = pl.currency;

           

            storageSet("clientId", pl.clientId);
            storageSet("activityId", pl.activityId);
            cookieSet("csrf", pl.csrf, 84600);

            if(storageGet("language") === "" || storageGet("language") === "undefined") {

                
                storageSet("language",pl.language[0]);
                state.selectedLanguage = pl.language[0];
            } else {
                state.selectedLanguage = storageGet("language");
            }

            if(storageGet("currency") === "") {
                storageSet("currency",pl.currency[0]);
                state.selectedCurrency = pl.currency[0]
            } else {
                state.selectedCurrency = storageGet("currency");
            }



            state.loading = false;
        });
        builder.addCase(getApps.rejected, (state, { payload }) => {
            state.loading = false;

        });
    }
});





export const { errorReducer, errorCloseReducer, setCaptcha } = AppSlice.actions;

export const AppReducer = AppSlice.reducer;